import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Admin } from "@mol-limo-reg/admin-api";
import { SnackbarService } from "../../../services/snackbar.service";
import { AdminService } from "../../../services/admin.service";
import { catchError, of } from "rxjs";

@Component({
  selector: 'app-activate-admin-dialog',
  templateUrl: './activate-admin-dialog.component.html',
  styleUrls: ['./activate-admin-dialog.component.scss']
})
export class ActivateAdminDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<ActivateAdminDialogComponent>,
    private snackbarService: SnackbarService,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: Admin
  ) {
  }

  ngOnInit(): void {
  }

  onActivateClicked(): void {
    let id = this.data.id;
    let name = this.data.name;
    let email = this.data.email;
    this.adminService.activateAdmin$(id)
      .pipe(
        catchError(() => {
          this.snackbarService.error(`”${name} (${email})” aktiválása során hiba lépett fel!`);
          this.dialogRef.close({ success: false });
          return of();
        })
      )
      .subscribe(() => {
        this.snackbarService.success(`”${name} (${email})” sikeresen aktiválva!`)
        this.dialogRef.close({ success: true });
      })
  }

}
